export const houstonZipMappings = {
  // CENTRAL
  '77002': { community: 'Downtown', region: 'Central', city: 'Houston' },
  '77003': { community: 'Downtown/EaDo', region: 'Central', city: 'Houston' },
  '77004': { community: 'Midtown/Museum District', region: 'Central', city: 'Houston' },
  '77005': { community: 'Museum District/Medical Center', region: 'Central', city: 'Houston' },
  '77006': { community: 'Montrose', region: 'Central', city: 'Houston' },
  '77007': { community: 'Heights/Near Northside', region: 'Central', city: 'Houston' },
  '77008': { community: 'Heights', region: 'Inner Loop North', city: 'Houston' },
  '77009': { community: 'Near Northside', region: 'Central', city: 'Houston' },
  '77010': { community: 'Downtown', region: 'Central', city: 'Houston' },
  '77019': { community: 'River Oaks/Montrose', region: 'West', city: 'Houston' },
  '77024': { community: 'Memorial/Tanglewood', region: 'West', city: 'Houston' },
  '77025': { community: 'Meyerland/Bellaire', region: 'Southwest', city: 'Houston' },
  '77027': { community: 'River Oaks/Greenway Plaza', region: 'Central', city: 'Houston' },
  '77030': { community: 'Medical Center/Museum District', region: 'Central', city: 'Houston' },
  '77098': { community: 'Upper Kirby/Greenway', region: 'Central', city: 'Houston' },
  
  // Add remaining ZIP codes from Day 1...
  // For brevity, including key ones. Full list should be added.
  
  '77401': { community: 'Bellaire', region: 'Southwest', city: 'Bellaire' },
  '77581': { community: 'Pearland', region: 'South', city: 'Pearland' },
  '77494': { community: 'Katy', region: 'West', city: 'Katy' },
};